import { useToast } from '@iheartjane/reefer';
import { useEffect } from 'react';

import { SpecialBundleEnticement } from '@jane/shared-ecomm/components';
import { useStoreProduct } from '@jane/shared-ecomm/data-access';
import { useMenu, useSpecials } from '@jane/shared-ecomm/providers';

export const MenuSpecialBundleEnticement = () => {
  const toast = useToast();
  const {
    appInfo: { bundlePossibilitiesState },
    dispatches: { clearTouchedProduct, onSpecialEnticementClick },
    paths,
    store,
  } = useMenu();
  const { specials } = useSpecials();

  const { touchedProductId, bundlePossibilities: bundle } =
    bundlePossibilitiesState || {};

  const { data: product } = useStoreProduct({
    productId: bundle ? Number(touchedProductId) : undefined,
    storeId: Number(store?.id),
  });

  useEffect(() => {
    if (bundle && product && specials && specials.length > 0) {
      const bundleSpecial = specials.find((s) => s.id === bundle.special_id);
      const qualifiedProduct =
        product?.applicable_bundle_special_ids?.qualify.includes(
          Number(bundleSpecial?.id)
        );

      if (bundleSpecial && qualifiedProduct) {
        toast.add({
          label: (
            <SpecialBundleEnticement
              bundlePossibilities={bundle}
              special={bundleSpecial}
              storeId={Number(store.id)}
              onClick={onSpecialEnticementClick}
              to={paths.menuSpecial({
                id: bundleSpecial.id,
                title: bundleSpecial.title,
              })}
            />
          ),
          'data-testid': 'bundle-enticement-toast',
          time: 4000,
        });
      }
    }

    return () => {
      if (touchedProductId) {
        clearTouchedProduct();
      }
    };
  }, [specials, store, product, bundle]);

  return null;
};
